<template>
  <el-form
    :inline="true"
    :model="query"
    :disabled="loading"
    label-position="top"
    ref="searchForm"
    @submit.native.prevent>
    <el-form-item
      v-for="option in options"
      :key="option">
      <el-input
        v-model="query[option]"
        :placeholder="$t(option)"/>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        @click="getList"
        :loading="loading">
        {{ $t('search') }}
      </el-button>
      <el-button
        type="text"
        @click="getAll"
        :disabled="loading"
        v-if="showReset">
        {{ $t('clear_search') }}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    mutation: {
      type: String,
      default: 'SET_USERS'
    },
    options: {
      type: Array,
      default: () => []
    },
    directQuery: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showReset: false,
      loading: false,
      query: {}
    }
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    getList () {
      const { name, query, mutation } = this
      if (this.directQuery) {
        this.$emit('list-updated', query)
      } else {
        const found = Object.values(query).find(item => item.length > 0)
        this.showReset = found
        this.toggleLoading()
        this.handleRequest({
          name,
          action: 'getAll',
          mutation,
          data: {
            query
          }
        }).then(res => {
          this.$emit('list-updated', query)
        }).finally(this.toggleLoading)
      }
    },
    getAll () {
      this.query = {}
      this.getList()
    },
    handleKeyPress (e) {
      let { key } = e
      if (key === 'Enter') {
        this.getList()
      }
    }
  },
  created () {
    const { options } = this
    for (let i = 0; i < options.length; i++) {
      this.query[options[i]] = ''
    }
    document.addEventListener('keypress', this.handleKeyPress)
  },
  beforeDestroy () {
    document.removeEventListener('keypress', this.handleKeyPress)
  }
}
</script>
